import { useState } from 'react';

const useFunction = () => {
    const [validationAction, setValidationAction] = useState();

    const setValidationActionWrapper = action => {
       
            // Weird - read this:
            // https://stackoverflow.com/questions/55621212/is-it-possible-to-react-usestate-in-react
            setValidationAction(() => () => action());
      
    };
    return [validationAction, setValidationActionWrapper]
}

    export default useFunction;
    